import React from 'react';

import { cn } from '~/utils/styles';

interface WaitingIndicatorProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const WaitingIndicator: React.FC<WaitingIndicatorProps> = ({ size = 'md', className }) => {
  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  };

  const spinnerSizeClasses = {
    sm: 'h-3 w-3 border',
    md: 'h-4 w-4 border-2',
    lg: 'h-6 w-6 border-2',
  };

  return (
    <div className={cn('flex items-center gap-1', sizeClasses[size], className)}>
      <div
        className={cn(
          'animate-spin rounded-full border-current border-t-transparent',
          spinnerSizeClasses[size],
        )}
      />
    </div>
  );
};

export default WaitingIndicator;
